import { molds as moldsGrabbed } from '../data/molds';
import { moldsExtra } from '../data/molds-extra';

const compare = (mold1, mold2) => {
  const { brand: brand1, title: title1 } = mold1;
  const { brand: brand2, title: title2 } = mold2;

  if (brand1 === brand2) {
    return title1.localeCompare(title2, 'fr', { ignorePunctuation: true, sensitivity: 'base' });
  }

  return brand1.localeCompare(brand2, 'fr', { ignorePunctuation: true, sensitivity: 'base' });
};

export const molds = moldsGrabbed.concat(moldsExtra).sort(compare);
